import Fade from "@mui/material/Fade";
import type { FunctionComponent } from "react";

import { Container, StyledBaseLink } from "./styles";

export type Props = {
  className?: string;
  isShow: boolean;
};

export const Indicator: FunctionComponent<Props> = ({ className, isShow }) => {
  const onLinkClick = () => {
    // sendGATracking({
    //   action: "My News/Index/TutorialIndicator/Click",
    //   category: "My News",
    //   label: "",
    // });
  };

  return (
    <Fade in={isShow} timeout={300}>
      <Container className={className}>
        Curating news that matters to you with our <span>Daily 5 must-read articles</span> plus a
        comprehensive list of stories from your favourite topics.{" "}
        <StyledBaseLink onClick={onLinkClick} pathname="/about-mynews">
          READ MORE
        </StyledBaseLink>
      </Container>
    </Fade>
  );
};

Indicator.displayName = "Indicator";
